import React, { useRef, useEffect } from 'react';
import { Formik } from 'formik';
import { Form, Button, Row, Col, Card, Alert } from 'react-bootstrap';
import Selector from 'react-select';
import { FaSearch } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

export default function FiltrosDebitos({
  onSubmit,
  isLoading,
  opcoes,
  contas,
  onCorretorChange,
  avisoData,
}) {
  const formikRef = useRef();

  const formatDateInput = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    const ano = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');
    return ano + '-' + mes + '-' + dia;
  };

  // Quando contas mudam (troca de corretor), atualizar campos de conta no Formik
  useEffect(() => {
    if (!formikRef.current) return;
    const { setFieldValue } = formikRef.current;

    if (contas && contas.length === 1) {
      setFieldValue('conta_portador', contas[0].conta_portador);
      setFieldValue('grupo_empresa', contas[0].grupo_empresa);
      setFieldValue('conta_selecionada', contas[0].conta_portador + '-' + contas[0].grupo_empresa);
    } else {
      setFieldValue('conta_portador', null);
      setFieldValue('grupo_empresa', null);
      setFieldValue('conta_selecionada', null);
    }
  }, [contas]);

  const optionsContas = (contas || []).map(item => ({
    value: item.conta_portador + '-' + item.grupo_empresa,
    label: item.descricao,
    contaPortador: item.conta_portador,
    grupoEmpresa: item.grupo_empresa,
  }));

  const optionsCorretores = (opcoes.corretores || []).map(item => ({
    value: item.codigo,
    label: item.descricao,
  }));

  const showCorretorSelector = opcoes.is_gerencial || opcoes.is_assessor;
  const showContaSelector = optionsContas.length >= 1;

  const initialValues = {
    data_inicial: formatDateInput(opcoes.data_trava),
    data_final: formatDateInput(new Date()),
    codigo_corretor: null,
    conta_portador: contas && contas.length === 1 ? contas[0].conta_portador : null,
    grupo_empresa: contas && contas.length === 1 ? contas[0].grupo_empresa : null,
    conta_selecionada: contas && contas.length === 1
      ? contas[0].conta_portador + '-' + contas[0].grupo_empresa
      : null,
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <strong>Visualize o relatorio de debito e credito por corretor.</strong>
      </Card.Header>
      <Card.Body>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="align-items-end mb-2">
                <Col xs={12} md={2}>
                  <Form.Group>
                    <Form.Label>Data Inicial:</Form.Label>
                    <Form.Control
                      type="date"
                      value={values.data_inicial}
                      onChange={e => setFieldValue('data_inicial', e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Form.Group>
                    <Form.Label>Data Final:</Form.Label>
                    <Form.Control
                      type="date"
                      value={values.data_final}
                      onChange={e => setFieldValue('data_final', e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                {showCorretorSelector && (
                  <Col xs={12} md={3}>
                    <Form.Group>
                      <Form.Label>Corretor:</Form.Label>
                      <Selector
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        options={optionsCorretores}
                        isClearable
                        placeholder="Selecione um corretor..."
                        value={optionsCorretores.find(o => o.value === values.codigo_corretor) || null}
                        onChange={option => {
                          const cod = option ? option.value : null;
                          setFieldValue('codigo_corretor', cod);
                          setFieldValue('conta_portador', null);
                          setFieldValue('grupo_empresa', null);
                          setFieldValue('conta_selecionada', null);
                          onCorretorChange(cod);
                        }}
                        noOptionsMessage={() => 'Nenhum corretor encontrado'}
                      />
                    </Form.Group>
                  </Col>
                )}

                {showContaSelector && (
                  <Col xs={12} md={3}>
                    <Form.Group>
                      <Form.Label>Selecione a conta:</Form.Label>
                      <Selector
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        options={optionsContas}
                        placeholder="Selecione uma conta..."
                        value={optionsContas.find(o => o.value === values.conta_selecionada) || null}
                        onChange={option => {
                          if (option) {
                            setFieldValue('conta_portador', option.contaPortador);
                            setFieldValue('grupo_empresa', option.grupoEmpresa);
                            setFieldValue('conta_selecionada', option.value);
                          } else {
                            setFieldValue('conta_portador', null);
                            setFieldValue('grupo_empresa', null);
                            setFieldValue('conta_selecionada', null);
                          }
                        }}
                        noOptionsMessage={() => 'Nenhuma conta encontrada'}
                      />
                    </Form.Group>
                  </Col>
                )}

                <Col xs={12} md={2}>
                  <Form.Group>
                    <Button
                      type="submit"
                      variant="success"
                      block
                      disabled={isLoading}
                    >
                      <FaSearch /> Filtrar Debitos
                    </Button>
                  </Form.Group>
                </Col>
              </Row>

              {avisoData && (
                <Alert variant="warning" className="mt-2 mb-0">
                  {avisoData}
                </Alert>
              )}
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
}
